
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import btbConf from '@/btb-conf.json';

@Component
export default class Email extends Vue {
    @Prop() accessibilityDescription!: string;
    @Prop() from?: string;
    @Prop() subject?: string;
    @Prop() fromIntro?: string;
    @Prop() subjectIntro?: string;
    @Prop() showTour?: boolean;
    @Prop({default : require('@/assets/attachment.png')}) attachmentImage?: string;
    @Prop() attachment?: string;
    @Prop() attachmentLink?: string;
    @Prop() attachmentIntro?: string;

    now : (string | undefined) = new Intl.DateTimeFormat(btbConf.courseInfo.localization, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(new Date()) 

    @Watch('showTour')
    onShowTourChanged(val: boolean, oldVal: boolean) {
      if(!oldVal && val)
        (this as any).$intro().start();
    }
    mounted(){
      if(this.showTour)
        (this as any).$intro().start();
      this.suppressLiveLinks();
      if(!this.now)
        this.now = new Intl.DateTimeFormat('en', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(new Date());
        
    }
    suppressLiveLinks(){
      Array.from(document.querySelectorAll('#EmailComponent a')).map((link)=>{
        link.addEventListener('click',this.suppressLink);
      });
    }
    suppressLink(e:Event){
      e.preventDefault();
    }
}
